import type { ComponentType, ReactNode } from 'react';

export type ShellNavItem = {
  to: string;
  label: string;
  icon: ReactNode;
  /** A count on the item (pending payments, new orders). */
  badge?: number;
  /** Active only on this exact path (the home page). */
  end?: boolean;
  /** Shown only on the phone or only on bigger screens. */
  only?: 'phone' | 'wide';
  /** Opens something (a sheet) instead of going to `to`, which then only names the item. */
  onSelect?: () => void;
};

export type ShellNavGroup = { label?: string; items: ShellNavItem[] };

/** The router's link, so the shells work with any router. */
export type ShellLinkProps = {
  to: string;
  className: string;
  'aria-current'?: 'page' | undefined;
  title?: string | undefined;
  onClick?: (() => void) | undefined;
  children: ReactNode;
};
export type ShellLink = ComponentType<ShellLinkProps>;

export function isPathActive(currentPath: string, to: string, end = false): boolean {
  const clean = (path: string) => (path.length > 1 ? path.replace(/\/+$/, '') : path);
  const current = clean(currentPath);
  const target = clean(to);
  if (end || target === '/') return current === target;
  return current === target || current.startsWith(`${target}/`);
}
